import React, { useState, useEffect } from 'react';
import { useParams, useNavigate } from 'react-router-dom';


const Fetch = () => {
  const { id } = useParams(); // Get the id from the URL parameters
  const [universityInfo, setUniversityInfo] = useState('');
  const [error, setError] = useState(null);
  const [activeTab, setActiveTab] = useState("description");
  const [reviewsContent, setReviewsContent] = useState('');
  const [username, setUsername] = useState(null);
  const [buttonText, setButtonText] = useState('APPLY NOW!'); // Initial button text
  const [isSaving, setIsSaving] = useState(false);
  const [saved, setSaved] = useState(false); // To track if save was successful
  const navigate = useNavigate();

	useEffect(() => {
	  const fetchRightContent = async () => {
		try {
		  const response = await fetch(`https://fetch.wordpad.workers.dev/collegenavigator/?id=${id}`);
		  const text = await response.text();

		  const parser = new DOMParser();
		  const doc = parser.parseFromString(text, 'text/html');
		  const rightContentDiv = doc.getElementById('RightContent');

		  if (rightContentDiv) {
			const universityData = extractUniversityData(rightContentDiv);
			setUniversityInfo(universityData);
			
			
			// Adding this line to store the entire RightContent div for the Reviews tab
          let dashboardDiv = rightContentDiv.querySelector('.dashboard');
          if (dashboardDiv) {
            dashboardDiv.remove();
          }
          dashboardDiv = rightContentDiv.querySelector('.expander');
          if (dashboardDiv) {
            dashboardDiv.remove();
          }			
          dashboardDiv = rightContentDiv.querySelector('.fadeyell');
          if (dashboardDiv) {
            dashboardDiv.remove();
          }			
		  
			setReviewsContent(rightContentDiv.innerHTML);
		  } else {
			setUniversityInfo('RightContent not found');
		  }
		} catch (err) {
		  setError('Failed to fetch the RightContent.');
		  console.error(err);
		}
	  };

    const extractUniversityData = (element) => {
      const name = element.querySelector('.headerlg')?.textContent.trim();
      const address = element.querySelector('.ipeds')?.previousSibling?.textContent.trim();
      const generalInfo = element.querySelector('.layouttab tr:nth-child(1) td:nth-child(2)')?.textContent.trim();
      const website = element.querySelector('.layouttab tr:nth-child(2) a')?.textContent.trim();
      const type = element.querySelector('.layouttab tr:nth-child(3) td:nth-child(2)')?.textContent.trim();
      const awardsOffered = Array.from(element.querySelectorAll('.layouttab tr:nth-child(4) td:nth-child(2) br')).map(br => br.previousSibling.textContent.trim()).join('\n');
      const campusSetting = element.querySelector('.layouttab tr:nth-child(5) td:nth-child(2)')?.textContent.trim();
      const campusHousing = element.querySelector('.layouttab tr:nth-child(6) td:nth-child(2)')?.textContent.trim();
      const studentPopulation = element.querySelector('.layouttab tr:nth-child(7) td:nth-child(2)')?.textContent.trim();
      const studentToFacultyRatio = element.querySelector('.layouttab tr:nth-child(8) td:nth-child(2)')?.textContent.trim();

      return `
        ${name}
        ${address}
        General information: ${generalInfo}
        Website: ${website}
        Type: ${type}
        Awards offered: 
		${awardsOffered} 
        Campus setting: ${campusSetting}
        Campus housing: ${campusHousing}
        Student population: ${studentPopulation}
        Student-to-faculty ratio: ${studentToFacultyRatio}
      `;
    };

    if (id) {
      fetchRightContent();
    }
  }, [id]); // Trigger the effect when id changes

  const handleTabClick = (tab) => {
    setActiveTab(tab);
  };

 // Implement stoggle function
  useEffect(() => {
    const stoggle = (id, event) => {
      event.preventDefault();
      console.log('stoggle called for ID:', id);
      
      const element = document.getElementById(id);
      console.log('Element found:', element);

      if (element) {
        const isCollapsed = element.classList.contains('detailOff');
        console.log('Is element collapsed?', isCollapsed);
        
        if (isCollapsed) {
          element.classList.remove('detailOff');
          element.classList.add('detailOn');
          console.log('Element expanded:', element);
        } else {
          element.classList.remove('detailOn');
          element.classList.add('detailOff');
          console.log('Element collapsed:', element);
        }
      } else {
        console.log('Element not found for ID:', id);
      }

    };

    // Add the stoggle function to the global window object so it can be used in the injected HTML
    window.stoggle = stoggle;
    console.log('stoggle function added to window.');
  }, []);
  
  const handleClick = async () => {
    // If the user clicks after a successful save, navigate to /profile
    if (saved) {
      navigate('/profile');
      return;
    }

    const storedUsername = localStorage.getItem('username');
    if (storedUsername) {
      setUsername(storedUsername);
      setButtonText('Saving...');
      setIsSaving(true);

      try {
        const response = await fetch(
          `https://b101favorites.wordpad.workers.dev/?username=${storedUsername}&favorite=${id}`,
          { method: 'POST' }
        );

        if (response.ok) {
          setButtonText('Go to Next Step');
          setIsSaving(false);
          setSaved(true); // Mark as saved
        } else {
          console.error('API call failed.');
          setButtonText('Try Again');
          setIsSaving(false);
        }
      } catch (err) {
        console.error('Error occurred while making the API call:', err);
        setButtonText('Try Again');
        setIsSaving(false);
      }
    }
  };
  
  
  return (
    <section className="detail-course detail-course--tabs">
            <a
        className="button button--primary reviews__btn"
        style={{ cursor: isSaving ? 'wait' : 'pointer' }} // Disable pointer if saving
        onClick={!isSaving ? handleClick : null} // Disable click if saving
      >
        {buttonText}
      </a>
	<style>
  {`
    .detailOff {
      display: none;
    }
    
    .detailOn {
      display: block;
    }
  `}
</style>
      <div className="detail-course__container container">
        <h1 className="detail-course__title">University Information</h1>
        <ul className="detail-course__tabs">
          <li
            className={`detail-course__tab ${activeTab === "description" ? "js-active" : ""}`}
            onClick={() => handleTabClick("description")}
          >
            Description
          </li>
          <li
            className={`detail-course__tab ${activeTab === "costs" ? "js-active" : ""}`}
            onClick={() => handleTabClick("costs")}
          >
            Courses and Costs
          </li>
          <li
            className={`detail-course__tab ${activeTab === "photos" ? "js-active" : ""}`}
            onClick={() => handleTabClick("photos")}
          >
            Photos
          </li>
          <li
            className={`detail-course__tab ${activeTab === "reviews" ? "js-active" : ""}`}
            onClick={() => handleTabClick("reviews")}
          >
            FULL DETAILS
          </li>
        </ul>

        {activeTab === "description" && (
          <div className="detail-course__body">
            {error ? <p>{error}</p> : <pre>{universityInfo}</pre>}
          </div>
        )}

        {activeTab === "costs" && (
          <div className="detail-course__body">
            <p>Courses and Costs information will be added here.</p>
          </div>
        )}

        {activeTab === "photos" && (
          <div className="detail-course__body">
            <p>Photos will be added here.</p>
          </div>
        )}

		{activeTab === "reviews" && (
		  <div className="detail-course__body">
			{reviewsContent ? (
			  <div dangerouslySetInnerHTML={{ __html: reviewsContent }} />
			) : (
			  <p>Loading reviews...</p>
			)}
		  </div>
		)}

      </div>
    </section>
  );
};

export default Fetch;
